"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesService = void 0;
class AgenciesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns information about the agency of the current user
     * @returns MyAgencyResponse
     * @throws ApiError
     */
    getMyAgency() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/me',
        });
    }
    /**
     * Returns the invite code for an agency
     * @param id
     * @returns AgencyCreatorInviteCodeResponse
     * @throws ApiError
     */
    getAgencyInviteCode(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/invite-code',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Deletes the invite code for an agency
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAgencyInviteCode(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/agencies/{id}/invite-code',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Creator joins an agency
     * @param code
     * @returns CreatorJoinAgencyResponse
     * @throws ApiError
     */
    creatorJoinAgency(code) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/creator-join-agency',
            query: {
                'code': code,
            },
        });
    }
    /**
     * Returns creators for an agency
     * @param id
     * @param status
     * @param page
     * @param count
     * @returns AgencyCreatorsResponse
     * @throws ApiError
     */
    getAgencyCreators(id, status, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/creators',
            path: {
                'id': id,
            },
            query: {
                'status': status,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns agency creators with open sponsorships
     * @param id
     * @param page
     * @param count
     * @returns AgencyCreatorsResponse
     * @throws ApiError
     */
    getAgencyCreatorsByOpenSponsorships(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/creators-by-sponsorships',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns agency campaigns with open sponsorships
     * @param id
     * @param page
     * @param count
     * @returns AgencyCampaignsResponse
     * @throws ApiError
     */
    getAgencyCampaignsByOpenSponsorships(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/campaigns-by-sponsorships',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns sponsorships for an agency
     * @param id
     * @param page
     * @param count
     * @returns AgencySponsorshipsResponse
     * @throws ApiError
     */
    getAgencySponsorships(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/sponsorships',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns the sponsorships of a creator
     * @param id
     * @param creatorId
     * @param page
     * @param count
     * @returns AgencySponsorshipsResponse
     * @throws ApiError
     */
    getAgencyCreatorSponsorships(id, creatorId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/creators/{creatorId}/sponsorships',
            path: {
                'id': id,
                'creatorId': creatorId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns the sponsorships of a campaign
     * @param id
     * @param campaignId
     * @param page
     * @param count
     * @returns AgencySponsorshipsResponse
     * @throws ApiError
     */
    getAgencyCampaignSponsorships(id, campaignId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/campaigns/{campaignId}/sponsorships',
            path: {
                'id': id,
                'campaignId': campaignId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get agency running sponsorships
     * @param id
     * @param page
     * @param count
     * @returns SponsorshipsResponse
     * @throws ApiError
     */
    getAgencyRunningSponsorships(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/running-sponsorships',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get agency completed sponsorships
     * @param id
     * @param page
     * @param count
     * @returns SponsorshipsResponse
     * @throws ApiError
     */
    getAgencyCompletedSponsorships(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/completed-sponsorships',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get agency sponsorships summary
     * @param id
     * @returns AgencySponsorshipsSummary
     * @throws ApiError
     */
    getAgencySponsorshipsSummary(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/sponsorships-summary',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get agency sponsorship by id
     * @param id
     * @param sponsorshipId
     * @returns SponsorshipResponse
     * @throws ApiError
     */
    getAgencySponsorshipById(id, sponsorshipId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
        });
    }
    /**
     * Start a sponsorship (outreached deployment)
     * @param id
     * @param sponsorshipId
     * @returns DeploymentResponse
     * @throws ApiError
     */
    startAgencySponsorshipById(id, sponsorshipId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}/start',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
        });
    }
    /**
     * Reject a sponsorship (outreached deployment)
     * @param id
     * @param sponsorshipId
     * @param requestBody RejectOfferPayload
     * @returns DeploymentResponse
     * @throws ApiError
     */
    rejectAgencySponsorshipById(id, sponsorshipId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}/reject',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get agency sponsorship preview (eligibility) by id
     * @param id
     * @param channelId
     * @param campaignGroupId
     * @returns SponsorshipResponse
     * @throws ApiError
     */
    getAgencySponsorshipPreviewById(id, channelId, campaignGroupId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/channels/{channelId}/sponsorships-preview/{campaignGroupId}',
            path: {
                'id': id,
                'channelId': channelId,
                'campaignGroupId': campaignGroupId,
            },
        });
    }
    /**
     * Starts an eligible sponsorship preview
     * @param id
     * @param channelId
     * @param campaignGroupId
     * @returns DeploymentResponse
     * @throws ApiError
     */
    startAgencySponsorshipPreviewById(id, channelId, campaignGroupId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/channels/{channelId}/sponsorships-preview/{campaignGroupId}/start',
            path: {
                'id': id,
                'channelId': channelId,
                'campaignGroupId': campaignGroupId,
            },
        });
    }
    /**
     * Rejects an eligible sponsorship preview
     * @param id
     * @param channelId
     * @param campaignGroupId
     * @param requestBody RejectOfferPayload
     * @returns DeploymentResponse
     * @throws ApiError
     */
    rejectAgencySponsorshipPreviewById(id, channelId, campaignGroupId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/channels/{channelId}/sponsorships-preview/{campaignGroupId}/reject',
            path: {
                'id': id,
                'channelId': channelId,
                'campaignGroupId': campaignGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change the sponsorship state to viewed
     * @param id
     * @param sponsorshipId
     * @returns DeploymentResponse
     * @throws ApiError
     */
    updateAgencySponsorshipViewed(id, sponsorshipId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}/viewed',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
        });
    }
    /**
     * Mark the preview sponsorship as viewed
     * @param id
     * @param channelId
     * @param campaignGroupId
     * @returns DeploymentResponse
     * @throws ApiError
     */
    updateAgencyPreviewSponsorshipViewed(id, channelId, campaignGroupId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/channels/{channelId}/sponsorships-preview/{campaignGroupId}/viewed',
            path: {
                'id': id,
                'channelId': channelId,
                'campaignGroupId': campaignGroupId,
            },
        });
    }
    /**
     * update agency manual deployment with start interest
     * @param id
     * @param sponsorshipId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateAgencyManualDeploymentWithStartInterest(id, sponsorshipId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}/start-interest',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * undo agency manual deployment start interest
     * @param id
     * @param sponsorshipId
     * @returns any Successful response
     * @throws ApiError
     */
    undoAgencyStartInterest(id, sponsorshipId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/sponsorships/{sponsorshipId}/undo-start-interest',
            path: {
                'id': id,
                'sponsorshipId': sponsorshipId,
            },
        });
    }
    /**
     * Send feedback for the agencies product
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendAgencyFeedback(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/feedback',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get agency payment url by type
     * @param id
     * @param type
     * @returns PaymentURLResponse
     * @throws ApiError
     */
    getAgencyPaymentUrl(id, type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/payment/url',
            path: {
                'id': id,
            },
            query: {
                'type': type,
            },
        });
    }
    /**
     * Suggest a sponsorship for a creator by agent
     * @param id
     * @param creatorId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    agencySuggestSponsorshipForCreator(id, creatorId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/creators/{creatorId}/suggest',
            path: {
                'id': id,
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Unassign a creator from an agency by agent
     * @param id
     * @param creatorId
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAgencyCreatorByAgent(id, creatorId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/agencies/{id}/creators/{creatorId}',
            path: {
                'id': id,
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Delete agencies cache
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAgenciesCache() {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/agencies/cache',
        });
    }
    /**
     * Returns information about a specific agencies in bulk
     * @param ids
     * @param requestBody
     * @returns DeploymentsStatsForCrm
     * @throws ApiError
     */
    getAgenciesBulk(ids, requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies',
            query: {
                'ids': ids,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns stats about all the agencies
     * @returns AgenciesStatsResponse
     * @throws ApiError
     */
    getAgenciesStats() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/stats',
        });
    }
    /**
     * Returns information about a specific agency
     * @param id
     * @param page
     * @param count
     * @returns AgencyDeploymentsResponse
     * @throws ApiError
     */
    getAgencyDeployments(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/deployments',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns information about a specific agents in bulk
     * @param ids
     * @param requestBody
     * @returns DeploymentsStatsForCrm
     * @throws ApiError
     */
    getAgentsBulk(ids, requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/agents',
            query: {
                'ids': ids,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Fix existing agency deployments to new flow
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    fixAgencyDeploymentsToNewFlow(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/fix-deployments',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Send manual agency digest email
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendManualAgencyDigestEmail(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/manual-digest',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send manual agency email test
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendManualAgencyEmailTest(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/manual-email-test',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send daily agency digest emails
     * @returns any Successful response
     * @throws ApiError
     */
    sendDailyAgencyDigestEmails() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/daily-digest',
        });
    }
    /**
     * Send weekly agency digest emails
     * @returns any Successful response
     * @throws ApiError
     */
    sendWeeklyAgencyDigestEmails() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/weekly-digest',
        });
    }
    /**
     * Agency block advertiser on behalf of creator
     * @param id
     * @param creatorId
     * @param advertiserId
     * @returns any Successful response
     * @throws ApiError
     */
    agencyBlockAdvertiser(id, creatorId, advertiserId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/creators/{creatorId}/block-advertiser/{advertiserId}',
            path: {
                'id': id,
                'creatorId': creatorId,
                'advertiserId': advertiserId,
            },
        });
    }
    /**
     * Agency unblock advertiser on behalf of creator
     * @param id
     * @param creatorId
     * @param advertiserId
     * @returns any Successful response
     * @throws ApiError
     */
    agencyUnblockAdvertiser(id, creatorId, advertiserId) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/creators/{creatorId}/unblock-advertiser/{advertiserId}',
            path: {
                'id': id,
                'creatorId': creatorId,
                'advertiserId': advertiserId,
            },
        });
    }
    /**
     * Update agency email preferences
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateAgencyEmailPreferences(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}/email-preferences',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get agency email preferences
     * @param id
     * @returns AgencyEmailPreferences
     * @throws ApiError
     */
    getAgencyEmailPreferences(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/agencies/{id}/email-preferences',
            path: {
                'id': id,
            },
        });
    }
}
exports.AgenciesService = AgenciesService;
